module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row product-dtl"
  }, [_c('div', {
    staticClass: "col-sm-4 d-flex flex-column"
  }, [_c('label', [_vm._v("Product:")]), _vm._v(" "), _c('span', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.reservation.event.product.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 d-flex flex-column"
  }, [_c('label', [_vm._v("Date / Time:")]), _vm._v(" "), _c('span', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.reservationDate) + " (" + _vm._s(_vm.eventDuration) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex flex-column"
  }, [_c('label', [_vm._v("Location:")]), _vm._v(" "), (_vm.reservation.event.location) ? _c('span', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.reservation.event.location))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 d-flex flex-column"
  }, [_c('label', [_vm._v("Resource" + _vm._s(_vm.reservation.event.eventResources.length > 1 ? 's' : '') + ":")]), _vm._v(" "), _c('v-select', {
    staticClass: "compact-dropdown-reservation-recourses w-100",
    class: {
      'notAllowed': _vm.isResourceDropdownDisabled
    },
    attrs: {
      "disabled": _vm.isResourceDropdownDisabled,
      "options": _vm.resourcesWithAvailability,
      "label": "name",
      "value": _vm.getResourceName
    },
    on: {
      "input": function($event) {
        return _vm.updateSelectedResource($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-baseline pr-3 w-100 view-evt"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewEvent.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "view-event-link"
  }, [_vm._v("View Event")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-af88b9ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af88b9ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/eventDetails.vue
// module id = 1923
// module chunks = 0